import React from 'react'
import { usePostRequest } from '../hooks/request'
import { MANTHLY_BALANCE_ITEM_LIST } from '../urls'

import ManthlyBalanceItemForm from './ManthlyBalanceItemForm'

export default function ManthlyBalanceItemCreate({ onCancel, onSuccess, finance, rotationId }) {
    const monthCreate = usePostRequest({ url: MANTHLY_BALANCE_ITEM_LIST.replace('{balanceId}', finance.id) })

    async function onSubmit(data) {
        const { success } = await monthCreate.request({ data })

        if (success) {
            onSuccess()
        }
    }

    return (
        <div>
            <b>Добавить</b><br /><br />
            <ManthlyBalanceItemForm
                finance={finance}
                rotationId={rotationId}
                onSubmit={onSubmit}
                onCancel={onCancel}
                loading={monthCreate.loading} />
        </div>
    )
}
